export class QPoint {
  constructor() {
    this.fX = 0;
    this.fY = 0;
  }

  InitPoint(x, y) {
    this.fX = x;
    this.fY = y;
  }

  Compare(aPoint) {
    if (aPoint.fX != this.fX) return false;
    if (aPoint.fY != this.fY) return false;

    return true;
  }

  Compare2(aPoint, x, y) {
    if (aPoint.fX != x) return false;
    if (aPoint.fY != y) return false;

    return true;
  }

  Shift(deltaX, deltaY) {
    this.fX = this.fX + deltaX;
    this.fY = this.fY + deltaY;
  }

  Scale(scaleFactor) {
    this.fX = this.fX * scaleFactor;
    this.fY = this.fY * scaleFactor;
  }
}
